import React, { useRef } from 'react'
import TextEditor from '../../../../../../../../../../../shared-components/TextEditor'
import DatePicker from '../../../../../../../../../../General/DatePicker'

const FollowUp = ({ widgetUtilities, ...props }) => {
    const quillFollowUpRef = useRef(null);

    const { 
        initialDataPatientName, initialDataAge, initialDataDOB, initialDataAddress, initialDataMobileNumber, initialDataEmail, 
        planData, setPlanData,
        // setSaveHPIData
    } = widgetUtilities;

    const handleChangeFreeText = (value, type) => {
        if (type === 'FollowUpNotes') {
            setPlanData(prev => ({
                ...prev, "FollowUpNotes": value,
            }));
        }
    }
  return (
    <div className="d-flex gap-10">
        <div className="ar-form-counter flex-center">
            <p className='text text-black'>{props?.itemCount}</p>
        </div>
    <div className="d-flex flex-column gap-6 w-100" 
    // id={scrollNavIDs.refPLANFollowUp} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refPLANFollowUp)} onClick={() => handleActiveItem(scrollNavIDs.refPLANFollowUp)}
    >
        <p className="heading fs-13" 
        // onClick={() => handleItemsExpanded('FollowUp')}
        >Follow-Up</p>
        {/* {!itemsCollapsed?.['FollowUp'] && */}
            <div className='observation-content d-flex flex-column gap-2'>
                <div className='input w-25'>
                    <DatePicker
                        label={'Date'}
                        id="FollowUpDate"
                        value={planData.FollowUpDate}
                        handleCalendarChangefunc={date => setPlanData(prev => ({ ...prev, 'FollowUpDate': date }))}
                    />
                </div>
                <div className="d-flex flex-column gap-6">
                    <p className="heading fs-13" >Notes</p>
                    <div className="">
                        <TextEditor
                            quillRef={quillFollowUpRef}
                            value={planData.FollowUpNotes}
                            setValue={(value) => handleChangeFreeText(value, 'FollowUpNotes')}
                            placeholderReplacement={true}
                            customDropDown={{
                                'active': true,
                                'options': [
                                    { value: initialDataPatientName, display: '$Name', },
                                    { value: initialDataAge, display: '$Age', },
                                    { value: initialDataDOB, display: '$DOB', },
                                    { value: initialDataAddress, display: '$Address', },
                                    { value: initialDataMobileNumber, display: '$Phone', },
                                    { value: initialDataEmail, display: '$Email', },
                                ]
                            }}
                            placeholder={"Detail followup notes..."}
                        />
                    </div>
                </div>
            </div>
        {/* } */}
    </div>
    </div>
  )
}

export default FollowUp